var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.71164 11.2998L11.3116 4.6998C11.4116 4.5998 11.52 4.5288 11.6366 4.4868C11.7533 4.44547 11.8783 4.4248 12.0116 4.4248C12.145 4.4248 12.27 4.44547 12.3866 4.4868C12.5033 4.5288 12.6116 4.5998 12.7116 4.6998L19.3116 11.2998C19.495 11.4831 19.591 11.7121 19.5996 11.9868C19.6076 12.2621 19.5116 12.4998 19.3116 12.6998C19.1283 12.8998 18.8993 13.0041 18.6246 13.0128C18.3493 13.0208 18.1116 12.9248 17.9116 12.7248L13.0116 7.8248L13.0116 18.9998C13.0116 19.2831 12.916 19.5208 12.7246 19.7128C12.5326 19.9041 12.295 19.9998 12.0116 19.9998C11.7283 19.9998 11.491 19.9041 11.2996 19.7128C11.1076 19.5208 11.0116 19.2831 11.0116 18.9998L11.0116 7.8248L6.11164 12.7248C5.9283 12.9081 5.69497 13.0041 5.41164 13.0128C5.1283 13.0208 4.89497 12.9248 4.71164 12.7248C4.51164 12.5415 4.41164 12.3081 4.41164 12.0248C4.41164 11.7415 4.51164 11.4998 4.71164 11.2998Z",
    fill: "url(#paint0_linear_1_5328)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_5328",
    x1: 19.6001,
    y1: 12.2123,
    x2: 4.41164,
    y2: 12.2123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.216667,
    stopColor: "#F9D71C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.a2eeec4b7f09014bfb8eacac4ea6bf40.svg";
export { ForwardRef as ReactComponent };